export const commonTranslations = {
    cancel: 'Cancelar',
    delete: 'Borrar',
    open: 'Abrir',
    back: 'Atrás',
    edit: 'Editar',
    loans: 'Préstamos',
    contacts: 'Contactos',
    email: 'Correo electrónico',
    iAgree: 'Estoy de acuerdo',
    continue: 'Continuar',
    finish: 'Finalizar',
    getStarted: 'Comenzar',
    downloadExport: 'Descargar Exportación',
    createLabel: '+ Crear {{createdLabel}}',
    saveContinue: 'Guardar y continuar',
    saveFinish: 'Guardar y finalizar',
    saveAndSubmit: 'Guardar y enviar',
    nextPage: 'Siguiente página',
    saveChanges: 'Guardar cambios',
    submit: 'Enviar',
    name: 'Nombre',
    enroll: 'Inscribir',
    missingInformation: 'Falta información',
    primary: 'Principal',
    financial: 'Financiero',
    signOut: 'Cerrar sesión',
    signIn: 'Iniciar sesión',
    yes: 'Sí',
    no: 'No',
    areaCode: 'Código postal',
    number: 'Número',
    extension: 'Extensión',
    total: 'Total',
    help: 'Ayuda',
    incomplete: 'Incompleto',
    confirmSelection: 'Confirmar selección',
    review: 'Revisar',
    logout: 'Cerrar sesión',
    logIn: 'Iniciar sesión',
    loanGroup: 'Grupo de préstamos',
    reasonOmitted: 'Motivo omitido',
    error: 'Error',
    existingSurvey: 'Encuesta existente',
    lastUpdated: 'Actualizado por última vez',
    targetPeriod: 'Plazo objetivo',
    dateSent: 'Fecha de envío',
    reminderSent: 'Recordatorio enviado',
    latestReviewNote: 'Nota de revisión más reciente',
    type: 'Tipo',
    view: 'Ver',
    required: 'Obligatorio',
    organization: 'Organización',
    organizationName: 'Nombre de la organización',
    returnToDashboard: 'Volver al tablero',
    you: 'Usted',
    yourContact: 'Tu perfil de contacto',
    returnHome: 'Regresar a la página principal',
    authenticated: 'Autenticado',
    revokeCredentials: 'Revocar credenciales',
    inviteToPlatform: 'Invitar a la plataforma',
    selectAllThatApply: 'Seleccionar todo lo que aplique',
    selectAll: 'Seleccionar todo',
    reset: 'Reiniciar',
    surveyType: 'Tipo de encuesta',
    ok: 'Aceptar',
    close: 'Cerrar',
    dontKnow: 'No sé',
    preferNotToAnswer: 'Prefiero no responder',
    discardUnsavedChanges: 'Descartar cambios no guardados',
    notPermitted: 'No tiene permiso para editar este campo.',
    startOnboardingDescription:
        "Ahora comenzará el proceso de incorporación para esta organización. Para comenzar, haga clic en el botón 'Comenzar la incorporación' a continuación.",
    startOnboarding: 'Comenzar la incorporación',
    questionHighlightedForClientsAttention:
        'Pregunta resaltada para llamar la atención del cliente en la última revisión.',
    links: {
        privacyPolicy: 'https://cictucson.org/privacy/',
        termsAndConds: 'https://cictucson.org/terms/',
        contactEmail: 'lending@cictucson.org'
    },
    statuses: {
        'In Progress': 'En progreso',
        Pending: 'Pendiente',
        Submitted: 'Enviado',
        Upcoming: 'Próximo',
        Accepted: 'Aceptado',
        Rejected: 'Requiere ajustes'
    },
    surveyTriggers: {
        intake: 'Admisión',
        biannual: 'Semestral',
        termination: 'Finalización',
        onboarding: 'Incorporación',
        financial: 'Financiero'
    },
    associatedUser: 'Usuario Asociado'
};
